import { computed, onUnmounted } from 'vue';
import store from '@/store';

export const useLoader = () => {
    const display = (active: boolean, text = 'Loading...') => {
        store.commit('loader', { active, text });
    };

    const updateText = (text: string) => {
        store.commit('loader', { ...store.state.loader, text });
    };

    const execLoadedFn = async (callback: () => Promise<unknown>, text?: string) => {
        display(true, text);
        try {
            await callback();
        } finally {
            display(false);
        }
    };

    onUnmounted(() => {
        display(false);
    });

    return {
        display,
        execLoadedFn,
        updateText,
        isLoading: computed(() => store.state.loader.active),
        loaderText: computed(() => store.state.loader.text)
    };
};
